// @flow

import React from 'react';
import { I18n } from 'react-redux-i18n';
import moment from 'moment';
import type { EventTile } from '../types/eventType';

export const months = [
  'Jan.',
  'Feb.',
  'Mar.',
  'Apr.',
  'May.',
  'Jun.',
  'Jul.',
  'Aug.',
  'Sep.',
  'Oct.',
  'Nov.',
  'Dec.',
];

export const getCurrentYear = (): number => moment().year();
export const getCurrentMonth = (): number => moment().month();

export const formatDateForMallEvents = (date: string): string => moment(date).format(I18n.t('date.long')).toString();

export const getYearOpeningStep = (openingStep: EventTile): number => moment(openingStep.info.split(' -')[0], I18n.t('date.long')).toDate().getFullYear();

export function timestampToISO(timestamp: number | string): string {
  return I18n.l(timestamp, { dateFormat: 'date.long' });
}

export const yearToMonth = x => Math.round(x * 12 * 100) / 100;
export const undoYearToMonth = x => x / 12;
export const monthToDay = x => x * 30;
export const undoMonthToDay = x => x / 30;
export const yearToMonthAndDay = (x: number) => {
  const monthAndDay = yearToMonth(x);
  const month = Math.floor(monthAndDay);
  const day = Math.round(monthToDay(monthAndDay) % 30);
  return { month, day };
};
export const undoYearToMonthAndDay = x => undoYearToMonth(x.month + undoMonthToDay(x.day));

export const getR12MonthYear = () => {
  const date = moment();
  if (date.date() > 15) {
    date.subtract({ months: 1 });
  } else {
    date.subtract({ months: 2 });
  }
  return `${date.format('MMM')}. ${date.year()}`;
};

export const secondsToMinutes = (seconds: number) => moment.duration(seconds, 'seconds').asMinutes();

